import { render, staticRenderFns } from "./index.vue?vue&type=template&id=24da8de0&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=24da8de0&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=24da8de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da8de0",
  null
  
)

export default component.exports